import { Image } from '@mui/icons-material'
import { Card, CardContent, Paper, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { motion } from 'framer-motion'
import React, { useEffect } from 'react'
import { makeRequest } from '../../util/AxiosInstance'
import { API_URL } from '../../zustand/const'

function PortfolioItem({ portfolio, setViewerId, setShowViewer }) {
    const [files, setFiles] = React.useState([]);

    const init = async () => {
        if (!portfolio) return;
        const fileIds = portfolio.image_order
        if (fileIds) {
            const filesResponse = await makeRequest('GET', `${API_URL}/file?id=${fileIds.join(',')}`);
            const sortedFiles = sortFilesByType(filesResponse.data.data);
            setFiles(sortedFiles);
        }
    }
    const sortFilesByType = (files) => {
        return files.sort((a, b) => {
            if (a.file_type.startsWith('video') && !b.file_type.startsWith('video')) return -1;
            if (!a.file_type.startsWith('video') && b.file_type.startsWith('video')) return 1;
            return 0;
        });
    };


    useEffect(() => {
        init()
    }, [portfolio])

    return (
        <Card
            onClick={() => {
                setViewerId(portfolio.id);
                setShowViewer(true);
            }}
            sx={{
                maxWidth: {
                    xs: '100%',
                    sm: '100%',
                },
                borderRadius: '1rem',
                transition: 'transform 0.2s',
                '&:hover': {
                    transform: 'scale(1.01)',
                }
            }} component={motion.div}>
            <Box>
                <img style={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover',
                }} src={Array.isArray(files) && files.length > 0 ? files[0].file_path : 'https://placehold.co/600x400?text=Portfolio+Image'} alt={portfolio.name} />
            </Box>
            <CardContent>
                <Typography textTransform={'capitalize'} variant='h6'>
                    {portfolio.name}
                </Typography>
                <Typography textTransform={'capitalize'} variant='body2' mt={1}>
                    {portfolio.category}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default PortfolioItem